import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Constant, VersionChange } from '../../constant';

@Component({
  selector: 'app-upgrade-dialog',
  templateUrl: './upgrade-dialog.component.html',
  styleUrls: ['./upgrade-dialog.component.scss']
})
export class UpgradeDialogComponent implements OnInit {
  versions: VersionChange[] = [];
  visibleVersions: number = 3;
  currentVersion: string = '';

  constructor(
    public dialogRef: MatDialogRef<UpgradeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private constant: Constant
  ) {}

  ngOnInit(): void {
    this.initializeVersions();
  }

  initializeVersions(): void {
    // Obtener versiones desde el servicio centralizado
    this.versions = this.constant.versionesCompletas;
    this.currentVersion = this.constant.version;
  }

  loadMoreVersions(): void {
    this.visibleVersions += 3;
    if (this.visibleVersions > this.versions.length) {
      this.visibleVersions = this.versions.length;
    }
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
